import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';

const metadataFieldChangeHandler = (
  fieldValue: Record<string, unknown>,
  formsList: FormField[][],
  index: number,
): FormField[][] => {
  if (index >= 0 && index < formsList.length) {
    const form = formsList[index];
    const [fieldName, value] = Object.entries(fieldValue)[0];

    const fieldIndex = form.findIndex(
      (field) => field.field_props.name === fieldName,
    );

    if (fieldIndex !== -1) {
      const updatedForms = [...formsList];
      const updatedForm = [...form];

      updatedForm[fieldIndex] = {
        ...updatedForm[fieldIndex],
        field_props: {
          ...updatedForm[fieldIndex].field_props,
          value: value as string,
          checked:
            updatedForm[fieldIndex].field_type === FieldType.Switch
              ? value
              : undefined,
        },
      } as FormField;

      updatedForms[index] = updatedForm;

      return updatedForms;
    }
  }

  return formsList;
};

export default metadataFieldChangeHandler;
